import React, {Fragment, Component} from 'react';
import * as authService from '../../services/auth';
import {Redirect} from 'react-router-dom';
import {user} from '../../modules/constants';

class LoginPage extends Component {
  state = {
    redirectToReferrer: false,
    login: '',
    password: '',
    showError: false,
  };

  handleSubmitLogin = (e) => {
    e.preventDefault();

    this.setState({
      showError: false,
    });

    if (btoa(encodeURIComponent(this.state.login)) === user.login
        && btoa(encodeURIComponent(this.state.password)) === user.password) {
      authService.login();
      this.setState({redirectToReferrer: true});
    }
    else {
      this.setState({
        showError: true,
      });
    }
  };

  handleInputChange = (e) => {
    let {value, name} = e.target;

    this.setState({
      [name]: value,
      showError: false,
    });
  };

  render() {
    let {from} = this.props.location.state || {from: {pathname: '/'}};
    let {redirectToReferrer} = this.state;
    if (redirectToReferrer) {
      return <Redirect to={from}/>;
    }

    return (
        <Fragment>
          <h1 className="login-header">You need to login before viewing this page.</h1>

          <form className="login-form" onSubmit={this.handleSubmitLogin}>
            <input
                type="text"
                className="input-login"
                placeholder="Username or Email"
                name='login'
                value={this.state.login}
                onChange={this.handleInputChange}
            />
            <input
                type="password"
                className="input-password"
                name='password'
                placeholder="Password"
                value={this.state.password}
                onChange={this.handleInputChange}
            />

            <button
                className="login-btn btn-large waves-effect waves-light blue lighten-1"
                onClick={this.loginHandler}
            >Login
            </button>

            {this.state.showError
                ? <div className="formError">Login or password are wrong</div>
                : null
            }
          </form>
        </Fragment>
    );
  }
}

export default LoginPage;


// WEBPACK FOOTER //
// ./src/containers/pages/LoginPage.js